import React from 'react';
import { useQuery } from '@apollo/client';
import { Outlet } from 'react-router-dom';
import { CurrentUserQuery } from '../queries';
import { NOT_FOUND } from '../constants/errors';

const SuperadminLayout = () => {
  const { loading, error, data } = useQuery(CurrentUserQuery, {
    context: { priorityOp: true },
  });

  if (loading) return null;
  if (error || !data.me?.superadminRole) throw new Error(NOT_FOUND);

  return <Outlet />;
};

export default SuperadminLayout;
